var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input',_vm._g({staticClass:"form-control",attrs:{"type":"password","autofocus":_vm.autofocus,"disabled":_vm.disabled,"readonly":_vm.readonly,"required":_vm.required,"value":_vm.value}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }